/*

Optionsauswahl mit Name, Beschreibung, Preis, Bild, Badge, Icons

 _______________    _______________    _______________
| (!)         @ |  |           $ # |  |             @ |
|     Bild      |  |     Bild      |  |     Bild      |
|               |  |               |  |               |
|_______________|  |_______________|  |_______________|
| erste   12,90 |  | zweite  27,10 |  | dritte   9,80 |
| Option        |  | Option        |  | Option        |
|_______________|  |_______________|  |_______________|

*/

import {formatPrice} from './helpers/general.js'
import './RadioCards.css'
import {Trans} from "@lingui/macro";

function RadioCards({name, options, selected, onChange, activeFilters, restrictions}) {
    // TODO artNum2Name für inkompatible Optionen implementieren

    function handleIncompatibles() {
        Array.from(document.getElementsByClassName("disabled")).forEach((e) => {
            e.classList.toggle("hide")
        });
    }

    function handleTooltipClick(e) {
        e.stopPropagation()
        e.preventDefault()
        return null
    }

    return (
        <>
            <div className="noneFound"><Trans>(keine passend zu den aktuellen Filtereinstellungen)</Trans></div>
            <div className="radioCards">
            {Object.keys(options).map((option, i) => (
                (
                    (!activeFilters?.washable || options[option].washable)
                    &&
                    (!activeFilters?.flameRetardant || options[option].flameRetardant)
                    &&
                    (!activeFilters?.firmness || options[option].hardness === activeFilters.firmness)
                    &&
                    (!activeFilters?.foamType || options[option].foamType === activeFilters.foamType)
                ) ?
                    <label key={i} className={'card' + ( (options[option].none ? ' none' : '' ) + ( (restrictions && restrictions[options[option].key]) ? ' disabled hide' : '' )) + (selected === options[option].key ? ' checked' : '')}>

                        {(restrictions && restrictions[options[option].key]) ? <div className="tooltip"><Trans>nicht kombinierbar mit</Trans> {restrictions[options[option].key]}</div> : ''}

                        {options[option].badges ?
                            <>
                                {options[option].badges.map((badge) => (
                                    <div key={badge.name} className='badge' style={{background: badge.background, color: badge.textcolor}}>{badge.text}</div>
                                ))}
                            </>
                            :
                            ''
                        }

                        {options[option].badge ? <div className='badge' style={{background: options[option].badge.background, color: options[option].badge.color}}>{options[option].badge.text}</div> : ''}
                        <div className="attributes">
                            {options[option].washable ? <div className="attribute"><i className="fa fa-check"></i> <Trans>Bezug waschbar</Trans></div> : ''}
                            {options[option].flameRetardant ? <div className="attribute"><i className="fa fa-check"></i> <Trans>Bezug flammhemmend</Trans></div> : ''}
                        </div>
                        <img src={options[option].img} className="img" />
                        {options[option].info ?
                            <div className='info' onClick={handleTooltipClick}>
                                <i className='fa fa-info-circle'></i>
                                <div className='tooltip' dangerouslySetInnerHTML={{__html: options[option].info}}></div>
                            </div>
                        :
                            null
                        }
                        <table className="data">
                            <tbody>
                                <tr>
                                    <td className='radio' rowSpan="2"><input type="radio" name={name} value={options[option].key} checked={selected === options[option].key} onChange={e => onChange(e.target.name, e.target.value)} disabled={(restrictions && restrictions[options[option].key]) ? true : false} /></td>
                                    <td className="name">{options[option].name}</td>
                                    <td className="price" rowSpan="2"><div>{(options[option].price ? formatPrice(options[option].price) : '')}</div></td>
                                </tr>
                                {options[option].more ? <tr><td><div className='more'>{options[option].more}</div></td></tr> : null}
                            </tbody>
                        </table>
                    </label>
                : ''
            ))}
        </div>
        </>
    )

}

export default RadioCards
